// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import * as SagaBase from '../../SagaBase';
import { CStamp } from '../../SagaSchema/CStamp';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class CStampProcedureAction_abstract extends CStamp {
  static $t: string = 'SagaSchema.CStampProcedureAction';
  $t: string = 'SagaSchema.CStampProcedureAction';

  public static GetMembers(): string[] {
    return [
      'ProcedureActionType',
      'EventId',
      'SelectedEventId',
      'SelectedProcedureId',
      'ProcedureGroup',
      'StepGuid',
      'Configuration',
      'Data',
      'StepDialogId',
      'StepDialogState'
    ].concat(CStamp.GetMembers());
  }

  public GetMembers(): string[] {
    return CStampProcedureAction_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ProcedureActionType: SagaBase.StampProcedureActionType = SagaBase.StampProcedureActionType.NextGroup;
  public EventId: number;
  public SelectedEventId: number;
  public SelectedProcedureId: number;
  public ProcedureGroup: number;
  public StepGuid: Guid = GuidTools.Empty;
  public Configuration: string;
  public Data: string;
  public StepDialogId: number;
  public StepDialogState: number;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
